import { render } from "./InquiryView.vue?vue&type=template&id=5de2f8b5&scoped=true"
import script from "./InquiryView.vue?vue&type=script&lang=js"
export * from "./InquiryView.vue?vue&type=script&lang=js"

import "./InquiryView.vue?vue&type=style&index=0&id=5de2f8b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de2f8b5"]])

export default __exports__